import { useMemo, useState } from 'react'
import { useSelector } from 'src/utils/store'
import { formatDatePlusThree } from 'src/utils/formatDate'
import { DeleteOutline, OpenInNew } from '@mui/icons-material'
import { capitalizeString } from 'src/utils/capitalize'
import { useDispatch } from 'react-redux'
import { actions } from '../../RestockingState'
import TableMui from 'src/components/TableMui'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { useHistory } from 'react-router-dom'

const TableListManagement = () => {
  const [openModalRemoveList, setOpenModalRemoveList] = useState(false)
  const [idOfListToRemove, setIdOfListToRemove] = useState<number>()
  const { restockingLists } = useSelector((state) => state.restocking)
  const dispatch = useDispatch()
  const history = useHistory()

  const onClickRemoveList = (id: number) => {
    setIdOfListToRemove(id)
    setOpenModalRemoveList(true)
  }

  const closeModal = () => setOpenModalRemoveList(false)

  const removeRestockingList = (idList: number) => {
    dispatch(actions.removeRestockingItem({
      commonId: idList,
      idToDelete: idList,
      itemName: 'lista',
      stateName: 'restockingLists',
      history,
    }))
    closeModal()
  }

  const resolveTableRows = useMemo(() => restockingLists?.map((item) => ({
    ...item,
    createdAt: formatDatePlusThree(item.createdAt),
    sourceType: capitalizeString(item.sourceType),
    level: capitalizeString(item.level),
    type: capitalizeString(item.type),
    startedAt: formatDatePlusThree(item.startedAt),
    finishedAt: formatDatePlusThree(item.finishedAt),
    userCreated: capitalizeString(item.userCreated),
    status: capitalizeString(item.status),
    open: (
      <OpenInNew
        sx={{ cursor: 'pointer' }}
        onClick={() => history.push(`/restocking/manage/pages/${item.id}`)}
        data-testid='open-list-button-test'
      />
    ),
    remove: (
      <DeleteOutline
        sx={{ color: 'red', cursor: 'pointer' }}
        onClick={() => onClickRemoveList(item.id)}
        data-testid='delete-list-button-test'
      />
    ),
  })), [history, restockingLists])

  return (
    <>
      <TableMui
        columns={[
          { id: 'createdAt', label: 'Data de criação' },
          { id: 'type', label: 'Tipo' },
          { id: 'sourceType', label: 'Subtipo' },
          { id: 'priority', label: 'Prioridade' },
          { id: 'level', label: 'Nível' },
          { id: 'startedAt', label: 'Data de início' },
          { id: 'finishedAt', label: 'Data de finalização' },
          { id: 'userCreated', label: 'Criado por' },
          { id: 'status', label: 'Status' },
          { id: 'open', label: 'Abrir' },
          { id: 'remove', label: 'Remover' },
        ]}
        emptyLabel='Utilize o filtro para buscar listas de reposição'
        rows={resolveTableRows}
        enablePagination
        rowsPerPageLimit={25}
        maxHeight='64vh'
        testId='list-management-table-test'
      />
      {
        idOfListToRemove
        && (
          <ConfirmOrRejectModal
            show={openModalRemoveList}
            title='Remover lista'
            description='Você tem certeza que deseja remover a lista?'
            onConfirm={() => removeRestockingList(idOfListToRemove)}
            onReject={closeModal}
            onClose={closeModal}
            dataTestId='modal-confirmation-delete-list'
          />
        )
      }
    </>
  )
}

export default TableListManagement
